import { render } from "./CreateCustomer.vue?vue&type=template&id=9cd0307e"
import script from "./CreateCustomer.vue?vue&type=script&lang=js"
export * from "./CreateCustomer.vue?vue&type=script&lang=js"

import "./CreateCustomer.vue?vue&type=style&index=0&id=9cd0307e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__